import {
    getProductList,
    retrieveProductDetails,
    getProductFilters,
    getMetricLevelDetails,
    saveMetricActionAssignment,
    updateMetricOwner,
    retrieveAllMetricOwners,
    retrieveOwnerFilters,
    updateMetricActionAssignment,deleteUserAccess,retrieveAllUsersToBeApprovedForProduct,addProductUser,
    retrieveMetricActionAssignment,getProductListForEdit,getProductUserPageFilters,retrieveAllUsersForProduct,updateUserAccessRequest,
    retrieveUserAccess,requestProductAccess,deleteMetricActionAssignment,verifyDrillDownTabData,
    saveBowlerChartFeedback,
    getAllRaisedFeedback,
    updateFeedbackStatus, deleteUserDashboardFilter, getUserDashboardFilter, getDashboardFilterNames, saveUserDashboardFilter
} from "@/config/DynamicApp/apiEndPoints";

//Generic BowlerChart
const getProductListForEditDetails = async (idToken) => {
    return {
        method: "get",
        url: `${getProductListForEdit}`,
        headers: {
            Authorization: `Bearer ${idToken}`,
            loggedInUser: sessionStorage.getItem('userEmail'),
            Accept: "application/json",
            "Content-Type": "application/json",
            "Access-Control-Allow-Origin": "*",
        },
        validateStatus(status) {
            return status >= 200 && status < 300 || status === 500 || status === 400
        }
    };
};
const retrieveAllUsersToBeApprovedForProductDetails = async (requestData, idToken) => {
    return {
        method: "post",
        url: `${retrieveAllUsersToBeApprovedForProduct}`,
        headers: {
            Authorization: `Bearer ${idToken}`,
            loggedInUser: sessionStorage.getItem('userEmail'),
            Accept: "application/json",
            "Content-Type": "application/json",
            "Access-Control-Allow-Origin": "*"
        },
        data: requestData,
        validateStatus(status) {
            return status >= 200 && status < 300 || status === 500 || status === 400
        }
    };
};
const addProductUserDetails = async (requestData, idToken) => {
    return {
        method: "post",
        url: `${addProductUser}`,
        headers: {
            Authorization: `Bearer ${idToken}`,
            loggedInUser: sessionStorage.getItem('userEmail'),
            Accept: "application/json",
            "Content-Type": "application/json",
            "Access-Control-Allow-Origin": "*"
        },
        data: requestData,
        validateStatus(status) {
            return status >= 200 && status < 300 || status === 500 || status === 400
        }
    };
};
const retrieveUserAccessDetails = async (requestData, idToken) => {
    return {
        method: "post",
        url: `${retrieveUserAccess}`,
        headers: {
            Authorization: `Bearer ${idToken}`,
            loggedInUser: sessionStorage.getItem('userEmail'),
            Accept: "application/json",
            "Content-Type": "application/json",
            "Access-Control-Allow-Origin": "*"
        },
        data: requestData,
        validateStatus(status) {
            return status >= 200 && status < 300 || status === 500 || status === 400
        }
    };
};
const requestProductAccessDetails = async (requestData, idToken) => {
    return {
        method: "post",
        url: `${requestProductAccess}`,
        headers: {
            Authorization: `Bearer ${idToken}`,
            loggedInUser: sessionStorage.getItem('userEmail'),
            Accept: "application/json",
            "Content-Type": "application/json",
            "Access-Control-Allow-Origin": "*"
        },
        data: requestData,
        validateStatus(status) {
            return status >= 200 && status < 300 || status === 500 || status === 400
        }
    };
};
const updateUserAccessRequestDetails = async (requestData, idToken) => {
    return {
        method: "post",
        url: `${updateUserAccessRequest}`,
        headers: {
            Authorization: `Bearer ${idToken}`,
            loggedInUser: sessionStorage.getItem('userEmail'),
            Accept: "application/json",
            "Content-Type": "application/json",
            "Access-Control-Allow-Origin": "*"
        },
        data: requestData,
        validateStatus(status) {
            return status >= 200 && status < 300 || status === 500 || status === 400
        }
    };
};
const retrieveOwnerFiltersDetails = async (requestData, idToken) => {
    return {
        method: "post",
        url: `${retrieveOwnerFilters}`,
        headers: {
            Authorization: `Bearer ${idToken}`,
            loggedInUser: sessionStorage.getItem('userEmail'),
            Accept: "application/json",
            "Content-Type": "application/json",
            "Access-Control-Allow-Origin": "*"
        },
        data: requestData,
        validateStatus(status) {
            return status >= 200 && status < 300 || status === 500 || status === 400
        }
    };
};
const getProductUserPageFiltersDetails = async (requestData, idToken) => {
    return {
        method: "post",
        url: `${getProductUserPageFilters}`,
        headers: {
            Authorization: `Bearer ${idToken}`,
            loggedInUser: sessionStorage.getItem('userEmail'),
            Accept: "application/json",
            "Content-Type": "application/json",
            "Access-Control-Allow-Origin": "*"
        },
        data: requestData,
        validateStatus(status) {
            return status >= 200 && status < 300 || status === 500 || status === 400
        }
    };
};
const retrieveAllUsersForProductDetails= async (requestData, idToken) => {
    return {
        method: "post",
        url: `${retrieveAllUsersForProduct}`,
        headers: {
            Authorization: `Bearer ${idToken}`,
            loggedInUser: sessionStorage.getItem('userEmail'),
            Accept: "application/json",
            "Content-Type": "application/json",
            "Access-Control-Allow-Origin": "*"
        },
        data: requestData,
        validateStatus(status) {
            return status >= 200 && status < 300 || status === 500 || status === 400
        }
    };
};
const deleteUserAccessDetails = async (requestData, idToken) => {
    return {
        method: "post",
        url: `${deleteUserAccess}`,
        headers: {
            Authorization: `Bearer ${idToken}`,
            loggedInUser: sessionStorage.getItem('userEmail'),
            Accept: "application/json",
            "Content-Type": "application/json",
            "Access-Control-Allow-Origin": "*"
        },
        data: requestData,
        validateStatus(status) {
            return status >= 200 && status < 300 || status === 500 || status === 400
        }
    };
};
const getProductListDetails = async (idToken) => {
    return {
        method: "get",
        url: `${getProductList}`,
        headers: {
            Authorization: `Bearer ${idToken}`,
            loggedInUser: sessionStorage.getItem('userEmail'),
            Accept: "application/json",
            "Content-Type": "application/json",
            "Access-Control-Allow-Origin": "*",
        },
        validateStatus(status) {
            return status >= 200 && status < 300 || status === 500 || status === 400
        }
    };
};

const retrieveProductDetailsList = async (productId,idToken) => {
    return {
        method: "get",
        url: `${retrieveProductDetails}?productId=${productId}`,
        headers: {
            Authorization: `Bearer ${idToken}`,
            loggedInUser: sessionStorage.getItem('userEmail'),
            Accept: "application/json",
            "Content-Type": "application/json",
            "Access-Control-Allow-Origin": "*",
        },
        validateStatus(status) {
            return status >= 200 && status < 300 || status === 500 || status === 400
        }
    };
};

const getProductFiltersDetails = async (requestData, idToken) => {
    return {
        method: "post",
        url: `${getProductFilters}`,
        headers: {
            Authorization: `Bearer ${idToken}`,
            loggedInUser: sessionStorage.getItem('userEmail'),
            Accept: "application/json",
            "Content-Type": "application/json",
            "Access-Control-Allow-Origin": "*"
        },
        data: requestData,
        validateStatus(status) {
            return status >= 200 && status < 300 || status === 500 || status === 400
        }
    };
};

const getMetricLevelDetailsList = async (requestData, idToken) => {
    return {
        method: "post",
        url: `${getMetricLevelDetails}`,
        headers: {
            Authorization: `Bearer ${idToken}`,
            loggedInUser: sessionStorage.getItem('userEmail'),
            Accept: "application/json",
            "Content-Type": "application/json",
            "Access-Control-Allow-Origin": "*"
        },
        data: requestData,
        validateStatus(status) {
            return status >= 200 && status < 300 || status === 500 || status === 400
        }
    };
};

const saveMetricActionAssignmentDetails = async (requestData, idToken) => {
    return {
        method: "post",
        url: `${saveMetricActionAssignment}`,
        headers: {
            Authorization: `Bearer ${idToken}`,
            loggedInUser: sessionStorage.getItem('userEmail'),
            Accept: "application/json",
            "Content-Type": "application/json",
            "Access-Control-Allow-Origin": "*"
        },
        data: requestData,
        validateStatus(status) {
            return status >= 200 && status < 300 || status === 500 || status === 400
        }
    };
};

const updateMetricOwnerDetails = async (requestData, idToken) => {
    return {
        method: "post",
        url: `${updateMetricOwner}`,
        headers: {
            Authorization: `Bearer ${idToken}`,
            loggedInUser: sessionStorage.getItem('userEmail'),
            Accept: "application/json",
            "Content-Type": "application/json",
            "Access-Control-Allow-Origin": "*"
        },
        data: requestData,
        validateStatus(status) {
            return status >= 200 && status < 300 || status === 500 || status === 400
        }
    };
};

const retrieveAllMetricOwnersDetails = async (requestData, idToken) => {
    return {
        method: "post",
        url: `${retrieveAllMetricOwners}`,
        headers: {
            Authorization: `Bearer ${idToken}`,
            loggedInUser: sessionStorage.getItem('userEmail'),
            Accept: "application/json",
            "Content-Type": "application/json",
            "Access-Control-Allow-Origin": "*"
        },
        data: requestData,
        validateStatus(status) {
            return status >= 200 && status < 300 || status === 500 || status === 400
        }
    };
};

const updateMetricActionAssignmentDetails = async (requestData, idToken) => {
    return {
        method: "post",
        url: `${updateMetricActionAssignment}`,
        headers: {
            Authorization: `Bearer ${idToken}`,
            loggedInUser: sessionStorage.getItem('userEmail'),
            Accept: "application/json",
            "Content-Type": "application/json",
            "Access-Control-Allow-Origin": "*"
        },
        data: requestData,
        validateStatus(status) {
            return status >= 200 && status < 300 || status === 500 || status === 400
        }
    };
};

const retrieveMetricActionAssignmentDetails = async (requestData, idToken) => {
    return {
        method: "post",
        url: `${retrieveMetricActionAssignment}`,
        headers: {
            Authorization: `Bearer ${idToken}`,
            loggedInUser: sessionStorage.getItem('userEmail'),
            Accept: "application/json",
            "Content-Type": "application/json",
            "Access-Control-Allow-Origin": "*"
        },
        data: requestData,
        validateStatus(status) {
            return status >= 200 && status < 300 || status === 500 || status === 400
        }
    };
};
const deleteMetricActionAssignmentDetails = async (requestData, idToken) => {
    return {
        method: "post",
        url: `${deleteMetricActionAssignment}`,
        headers: {
            Authorization: `Bearer ${idToken}`,
            loggedInUser: sessionStorage.getItem('userEmail'),
            Accept: "application/json",
            "Content-Type": "application/json",
            "Access-Control-Allow-Origin": "*"
        },
        data: requestData,
        validateStatus(status) {
            return status >= 200 && status < 300 || status === 500 || status === 400
        }
    };
};
const verifyDrillDownTabDataDetails = async (requestData, idToken) => {
    return {
        method: "post",
        url: `${verifyDrillDownTabData}`,
        headers: {
            Authorization: `Bearer ${idToken}`,
            loggedInUser: sessionStorage.getItem('userEmail'),
            Accept: "application/json",
            "Content-Type": "application/json",
            "Access-Control-Allow-Origin": "*"
        },
        data: requestData,
        validateStatus(status) {
            return status >= 200 && status < 300 || status === 500 || status === 400
        }
    };
};

const saveBowlerChartFeedbackDetails = async (requestData, idToken) => {
    return {
        method: "post",
        url: `${saveBowlerChartFeedback}`,
        headers: {
            Authorization: `Bearer ${idToken}`,
            loggedInUser: sessionStorage.getItem('userEmail'),
            Accept: "multipart/form-data",
            "Content-Type": "multipart/form-data",
            "Access-Control-Allow-Origin": "*"
        },
        data: requestData,
        validateStatus(status) {
            return status >= 200 && status < 300 || status === 500 || status === 400
        }
    };
};

const getAllRaisedFeedbackDetails = async (requestData, idToken) => {
    return {
        method: "post",
        url: `${getAllRaisedFeedback}`,
        headers: {
            Authorization: `Bearer ${idToken}`,
            loggedInUser: sessionStorage.getItem('userEmail'),
            Accept: "application/json",
            "Content-Type": "application/json",
            "Access-Control-Allow-Origin": "*"
        },
        data: requestData,
        validateStatus(status) {
            return status >= 200 && status < 300 || status === 500 || status === 400
        }
    };
};

const updateFeedbackStatusDetails = async (requestData, idToken) => {
    return {
        method: "post",
        url: `${updateFeedbackStatus}`,
        headers: {
            Authorization: `Bearer ${idToken}`,
            loggedInUser: sessionStorage.getItem('userEmail'),
            Accept: "application/json",
            "Content-Type": "application/json",
            "Access-Control-Allow-Origin": "*"
        },
        data: requestData,
        validateStatus(status) {
            return status >= 200 && status < 300 || status === 500 || status === 400
        }
    };
};
const getDashboardFilterNamesDetails = async (requestData, idToken) => {
    return {
        method: "post",
        url: `${getDashboardFilterNames}`,
        headers: {
            Authorization: `Bearer ${idToken}`,
            loggedInUser: sessionStorage.getItem('userEmail'),
            Accept: "application/json",
            "Content-Type": "application/json",
            "Access-Control-Allow-Origin": "*"
        },
        data: requestData,
        validateStatus(status) {
            return status >= 200 && status < 300 || status === 500 || status === 400
        }
    };
};
const deleteUserDashboardFilterDetails = async (requestData, idToken) => {
    return {
        method: "post",
        url: `${deleteUserDashboardFilter}`,
        headers: {
            Authorization: `Bearer ${idToken}`,
            loggedInUser: sessionStorage.getItem('userEmail'),
            Accept: "application/json",
            "Content-Type": "application/json",
            "Access-Control-Allow-Origin": "*"
        },
        data: requestData,
        validateStatus(status) {
            return status >= 200 && status < 300 || status === 500 || status === 400
        }
    };
};
const getUserDashboardFilterDetails = async (requestData, idToken) => {
    return {
        method: "post",
        url: `${getUserDashboardFilter}`,
        headers: {
            Authorization: `Bearer ${idToken}`,
            loggedInUser: sessionStorage.getItem('userEmail'),
            Accept: "application/json",
            "Content-Type": "application/json",
            "Access-Control-Allow-Origin": "*"
        },
        data: requestData,
        validateStatus(status) {
            return status >= 200 && status < 300 || status === 500 || status === 400
        }
    };
};
const saveUserDashboardFilterDetails = async (requestData, idToken) => {
    return {
        method: "post",
        url: `${saveUserDashboardFilter}`,
        headers: {
            Authorization: `Bearer ${idToken}`,
            loggedInUser: sessionStorage.getItem('userEmail'),
            Accept: "application/json",
            "Content-Type": "application/json",
            "Access-Control-Allow-Origin": "*"
        },
        data: requestData,
        validateStatus(status) {
            return status >= 200 && status < 300 || status === 500 || status === 400
        }
    };
};

export default {
    getProductListDetails,
    retrieveProductDetailsList,
    getProductFiltersDetails,
    getMetricLevelDetailsList,
    saveMetricActionAssignmentDetails,
    updateMetricOwnerDetails,
    retrieveAllMetricOwnersDetails,
    retrieveOwnerFiltersDetails,
    updateMetricActionAssignmentDetails,retrieveAllUsersForProductDetails,deleteUserAccessDetails,addProductUserDetails,retrieveUserAccessDetails,
    retrieveMetricActionAssignmentDetails,getProductListForEditDetails,getProductUserPageFiltersDetails,retrieveAllUsersToBeApprovedForProductDetails,
    requestProductAccessDetails,updateUserAccessRequestDetails,deleteMetricActionAssignmentDetails,verifyDrillDownTabDataDetails,
    saveBowlerChartFeedbackDetails,
    getAllRaisedFeedbackDetails,
    updateFeedbackStatusDetails,
    deleteUserDashboardFilterDetails,
    getUserDashboardFilterDetails,
    saveUserDashboardFilterDetails,
    getDashboardFilterNamesDetails
}
